import { render, staticRenderFns } from "./NotificationSideBar.vue?vue&type=template&id=a68cff7c"
import script from "./NotificationSideBar.vue?vue&type=script&lang=js"
export * from "./NotificationSideBar.vue?vue&type=script&lang=js"
import style0 from "./NotificationSideBar.vue?vue&type=style&index=0&id=a68cff7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports